export default function customer(state = { }, action) {
  switch (action.type) {
    case 'customer_list_SUCCESS':
      return { ...state, data: action.payload.data, error: null }
    case 'customer_list_FAIL':
      return { ...state, error: action.payload.error.reponse.data }
    case 'customer_lead_SUCCESS':
      return { ...state, leadData: action.payload.data, error: null }
    case 'customer_lead_FAIL':
      return { ...state, error: action.payload.error.reponse.data }
    case 'customer_update':
      var customer = action.payload.request.data;
      if(state.data) {
        var i = state.data.findIndex(e => e._id == customer._id);
        if (i >= 0) {
          state.data[i] = customer;
        }
      }
      if(state.leadData && customer.processResults == 'LE') {
        var j = state.leadData.findIndex(e => e._id == customer._id);
        if (j >= 0) {
          state.leadData[j] = customer;
        }
      }
      return {...state};
    case 'customer_update_SUCCESS':

      var customer = action.payload.data;

      if(state.data) {
        var data = state.data;
        var find = data.filter(e => e._id == customer._id)[0];
        if (find) {
          var i = data.indexOf(find);
          data[i] = customer;
        } else {
          data.push(customer);
        }
      }

      if(state.leadData && customer.processResults == 'LE') {
        var leadData = state.leadData;
        var findl = leadData.filter(e => e._id == customer._id)[0];
        if (findl) {
          var i = leadData.indexOf(findl);
          leadData[i] = customer;
        } else {
          leadData.push(customer);
        }
      }

      return {
        ...state,
        data: [].concat(data),
        leadData: [].concat(leadData)
      }
    case 'customer_update_FAIL':
      return { ...state, error: action.payload.error.reponse.data }
    case 'customer_remove':
      var customer = action.payload.request.data;

      if(state.data) {
        var data = state.data;
        data = data.filter(e => e._id !== customer._id);
      }

      if(state.leadData && customer.processResults == 'LE') {
        var leadData = state.leadData;
        leadData = leadData.filter(e => e._id !== customer._id);
      }
      return {
        ...state,
        data: [].concat(data),
        leadData: [].concat(leadData)
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./client/reducers/customer.js